import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventScore } from 'src/domains/sportsbook/betting/ui/betSlip/EventScore';
import { SingleBetItemState } from 'src/domains/sportsbook/betting/betSlipState/betsState/SingleBetItemState';
import { useAppStateContext } from 'src/appState/AppState';
import { WinReduction } from 'src/domains/sportsbook/betting/bettingTab/cashout/selection/selectionNew/legsInBet/WinReduction';
import { LegMarketInfo } from 'src/domains/sportsbook/betting/bettingTab/cashout/selection/selectionNew/legsInBet/LegMarketInfo';
import { EachWayTerms } from 'src/domains/sportsbook/betting/bettingTab/cashout/selection/selectionNew/legsInBet/EachWayTerms';
import { LegName } from 'src/domains/sportsbook/betting/bettingTab/cashout/selection/selectionNew/legsInBet/LegName';
import { RabSelections } from 'src/domains/sportsbook/betting/bettingTab/cashout/selection/selectionNew/legsInBet/RabSelections';
import { LegViewState } from 'src/domains/sportsbook/betting/bettingTab/cashout/selection/selectionNew/legsInBet/LegsInBet.state';
import { useCommon } from 'src/domains/common/Common';

interface PropsType {
    betItem: SingleBetItemState;
}

export const LegsInBet = observer('LegsInBet', ({ betItem }: PropsType) => {
    const { appSportsBookState } = useAppStateContext();
    const { betsState } = appSportsBookState;
    const common = useCommon();

    const legs = betItem.legs.map((leg) => new LegViewState(common, leg, betsState, betItem));

    return (
        <div>
            {legs.map((item) => (
                <React.Fragment key={item.id}>
                    <LegName
                        dataTest={item.selectionName === '' ? undefined : 'selection-name'}
                        isSettled={item.isSettled}
                        isShowBogIndicator={item.isShowBogIndicator}
                        marketId={item.newMarketId}
                        price={item.price}
                        resultStatus={item.leg.result?.type}
                        selectionId={item.leg.selection?.id ?? null}
                        selectionName={item.selectionName}
                    />

                    {item.eventId !== null && <EventScore eventId={item.eventId} />}

                    <LegMarketInfo
                        leg={item.leg}
                        marketId={item.newMarketId}
                    />

                    {item.isShowSPPrice && item.spPrice !== null && <div>{`SP Price ${item.spPrice}`}</div>}

                    {(item.leg.type === 'rab' || item.leg.type === 'betBuilder') && (
                        <RabSelections selections={item.leg.selections ?? []} />
                    )}

                    {item.numDenVal !== null &&
                        item.leg.eachWayTerms !== null &&
                        item.leg.eachWayTerms !== undefined && (
                            <EachWayTerms
                                eachWayTerms={item.leg.eachWayTerms}
                                numDenVal={item.numDenVal}
                            />
                        )}

                    {item.resultWinReduction !== null && item.resultWinReduction.trim() !== '' && (
                        <WinReduction resultWinReduction={item.resultWinReduction} />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
});
